import { config } from './config';
import { demoDataSource } from './sources/mock';
import { restDataSource } from './sources/rest';
import type { PanDataSource } from './types';

/**
 * Composition root da camada de dados: a escolha entre API real e demo acontece
 * uma única vez, aqui. Nenhuma tela importa `restDataSource` ou `demoDataSource`
 * diretamente — todas recebem `PanDataSource`.
 */
export const dataSource: PanDataSource = config.dataSource === 'rest' ? restDataSource : demoDataSource;

export * from './types';
export { config, CAPACIDADE_POR_HORARIO, JANELA_AGENDAMENTO, RETENCAO_TTL_SEGUNDOS } from './config';
